import type { Action } from '../action'
import type { Op } from '../op'

/**
 * TODO:
 *
 * This function helps with type inferrence
 */
export function standalone<TState, TInputData, TData>(
  config: {
    readonly data: (input: TInputData) => TData
  } & Readonly<
    Pick<
      Action.constructor.Params<TState, any, TData>,
      'reducer' | 'reducerDeprecated'
    >
  >,
) {
  return {
    ...config,
    [Config.OP_TYPE_KEY]: 'standalone',
  } as const
}

/**
 * TODO:
 *
 * This function helps with type inferrence
 */
export function request<
  TState,
  TRequestInput,
  TRequest,
  TResponseInput,
  TResponse,
>(config: {
  readonly input: (request: TRequestInput) => TRequest
  readonly output: (response: TResponseInput) => TResponse
  readonly reducers?: {
    readonly [TOpStatus in Op.Status]?: Action.constructor.Params<
      TState,
      Op<string, TOpStatus>,
      Op.Status.Data<TOpStatus, NoInfer<TRequest>, NoInfer<TResponse>>
    >['reducer']
  }
  /** @deprecated Use {@link reducers} */
  readonly reducersDeprecated?: {
    readonly [TOpStatus in Op.Status]?: Action.constructor.Params<
      TState,
      Op<any, TOpStatus>,
      Op.Status.Data<TOpStatus, NoInfer<TRequest>, NoInfer<TResponse>>
    >['reducerDeprecated']
  }
}) {
  return { ...config, [Config.OP_TYPE_KEY]: 'request' } as const
}

export namespace Config {
  export type Constraint<TState = any> = Record<
    string,
    RequestOp<TState> | StandaloneOp<TState>
  >
  export type Default = Record<string, never>

  export const OP_TYPE_KEY = '__op_type__'

  export type RequestOp<
    TState,
    TRequestInput = any,
    TRequest = any,
    TResponseInput = any,
    TResponse = any,
  > = ReturnType<
    typeof request<TState, TRequestInput, TRequest, TResponseInput, TResponse>
  >

  export type StandaloneOp<TState, TInputData = any, TData = any> = ReturnType<
    typeof standalone<TState, TInputData, TData>
  >
}
